var Component = require("!../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./DetalhesTaxas.vue"),
  /* template */
  require("!!../../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-b5411294\"}!../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./DetalhesTaxas.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/Imoveis/Detalhes/DetalhesTaxas.vue
// module id = 938
// module chunks = 1